import { GROUPLEVELS_FOUNDATION } from 'containers/User/constants.js';
import useCurrentRole from 'containers/User/useCurrentRole.js';

function useIsFoundation() {
  const { school } = useCurrentRole();
  return school.type === GROUPLEVELS_FOUNDATION;
}

export default useIsFoundation;
